import * as actionTypes from './actionsTypes';
import {textyZakladni ,textyKompletni} from '../../shared/Texty';


export const setDefaultOn = () => {
  return{
    type: actionTypes.SET_DEFAULT_TEXT_ON,

  } 
}




export const findText = (id) => {

    
     return dispatch => {
        

        const PartIndex = textyZakladni.text.findIndex(p =>
          {
            return p.id === id;
          })
         
          // udelam si kopii vybrane casti tela
        const foundText = {
          ...textyZakladni.text[PartIndex]
        }

        

        dispatch(setText(
            foundText.id,
            foundText.name,
            foundText.img,
            foundText.img2,
            foundText.textSvis,
            foundText.textVod))
     }    



}

export const findTextKompl = (id) => {
  return dispatch => {
   // console.log('toto je moje id:' + id)

    const PartIndex = textyKompletni.text.findIndex(p =>
      {
        return p.id === id;
      })
     
      // udelam si kopii vybrane casti tela
    const foundText = {
      ...textyKompletni.text[PartIndex]
    }

    

    dispatch(setText(
        foundText.id,
        foundText.name,
        foundText.img,
        foundText.img2,
        foundText.textSvis,
        foundText.textVod))
 }    


}


export const setText = (id,name,img,img2,textSvis,textVod) => {
   // console.log('aa mam to',id,img,textSvis,textVod)
    return {
        type: actionTypes.SET_TEXT,
        id : id,
        name: name,
        img: img,
        img2:img2,
        textSvis:textSvis,
        textVod:textVod
    };
    
};

export const showModal = (img) => {
  return {
    type: actionTypes.SHOW_MODAL,
    modalImg: img
  }
}

export const closeModal = () => {
  return {
    type: actionTypes.CLOSE_MODAL
  }
}
